module.exports = __webpack_public_path__ + "static/media/icon_h2.9b01d2d9.svg";